import React from "react";
import { Router } from "react-router-dom";
import { Provider } from "react-redux";
import ReactGA from "react-ga";
import createStore from "./src/state";

exports.replaceRouterComponent = ({ history }) => {
  const store = createStore();
  const ConnectedRouterWrapper = ({ children }) => (
    <Provider store={store}>
      <Router history={history}>{children}</Router>
    </Provider>
  );
  return ConnectedRouterWrapper;
};

exports.onClientEntry = () => {
  if (process.env.NODE_ENV === "production") {
    ReactGA.initialize(process.env.GA_TRACKING_ID, { debug: true });
    const { pathname, search } = window.location;
    ReactGA.set({ page: `${pathname}${search}` });
    ReactGA.pageview(`${pathname}${search}`);
  }
};



// WEBPACK FOOTER //
// ./gatsby-browser.js